import { DetailCardSection, DetailList, DetailRow, formatDateTime, IdValue } from "@prequel/shared-components";

import { useDatalakeContext } from "@/pages/import/DatalakesPage/DatalakePage";
import VendorBadge from "@/pages/import/DatalakesPage/VendorBadge";

const DatalakeDetails = () => {
  const { datalake } = useDatalakeContext();

  return (
    <DetailCardSection title="Details">
      <DetailList>
        <DetailRow label="ID" value={<IdValue id={datalake.id} />} />
        <DetailRow label="Name" value={datalake.name} />
        <DetailRow label="Vendor" value={<VendorBadge storage={datalake.storage} />} />

        {datalake.retention_window_days != null && (
          <DetailRow label="Retention" value={`${datalake.retention_window_days} days`} />
        )}

        {datalake.storage === "s3" && (
          <>
            <DetailRow label="Bucket" value={datalake.s3.bucket_name} />
            <DetailRow label="Region" value={datalake.s3.bucket_region} />
            {datalake.s3.prefix && <DetailRow label="Prefix" value={datalake.s3.prefix} />}
            {datalake.s3.auth_method === "aws_iam_role" && (
              <DetailRow label="IAM Role" value={datalake.s3.aws_iam_role.aws_iam_role_arn} />
            )}
          </>
        )}

        {datalake.storage === "s3_compatible" && (
          <>
            <DetailRow label="Bucket" value={datalake.s3_compatible.bucket_name} />
            <DetailRow label="Region" value={datalake.s3_compatible.bucket_region} />
            {datalake.s3_compatible.prefix && <DetailRow label="Prefix" value={datalake.s3_compatible.prefix} />}
          </>
        )}

        {datalake.storage === "gcs" && (
          <>
            <DetailRow label="Bucket" value={datalake.gcs.bucket_name} />
            <DetailRow label="Region" value={datalake.gcs.bucket_region} />
            {datalake.gcs.prefix && <DetailRow label="Prefix" value={datalake.gcs.prefix} />}
            {datalake.gcs.auth_method === "gcp_service_account_role" && (
              <DetailRow
                label="Service Account"
                value={datalake.gcs.gcp_service_account_role.gcp_service_account_email}
              />
            )}
          </>
        )}

        {datalake.storage === "abs" && (
          <>
            <DetailRow label="Container" value={datalake.abs.container_name} />
            <DetailRow label="Storage Account" value={datalake.abs.storage_account_name} />
            {datalake.abs.prefix && <DetailRow label="Prefix" value={datalake.abs.prefix} />}
          </>
        )}

        <DetailRow label="Created at" value={formatDateTime(datalake.created_at)} />
        <DetailRow label="Updated at" value={formatDateTime(datalake.updated_at)} />
      </DetailList>
    </DetailCardSection>
  );
};

export default DatalakeDetails;
